export interface BenefitScheduleDetailsFromFileName {
  policyNumber?: string;
  renewalNumber?: string;
  memberType?: string;
}

export const getBenefitScheduleDetailsByName = (
  benefitScheduleName: string | undefined,
): BenefitScheduleDetailsFromFileName => {
  // e.g. "CH_88000633_1_0.pdf"
  if (benefitScheduleName) {
    const policyDetails = benefitScheduleName.replace('.pdf', '').split('_');
    const policyNumber: string = policyDetails[1];
    const renewalNumber: string = policyDetails[2];
    const memberType: string = policyDetails[3];

    return {
      policyNumber,
      renewalNumber,
      memberType,
    };
  }
  return {};
};
